import axiosInstance from "./api_helper";

const deliveryService = {

    list: async ({dateFrom, dateTo,query}) => {
        const params = {};
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (query) params.query = query;

        const response = await axiosInstance.get(`/api/ventes/bon-livraison`, { params });
        return response.data;
    },

    add: async (deliveryData) => {
        return await axiosInstance.post('/api/ventes/bon-livraison-direct', deliveryData.data);
    },
    update: async (id, data) => {
        try {
            const response = await axiosInstance.put(`/api/ventes/bon-livraison/${id}`, JSON.stringify(data));
            return response;
        } catch (error) {
            throw error;
        }
    },
    findLigneBLReport: async ({ articleId, dateFrom, dateTo, query }) => {
        try {
            const params = {};
            if (articleId !== undefined && articleId !== null) params.articleId = articleId;
            if (dateFrom) params.dateFrom = dateFrom;
            if (dateTo) params.dateTo = dateTo;
            if (query) params.query = query;
            const response = await axiosInstance.get('/api/ventes/bon-livraison/report', { params });
            return response;
        } catch (error) {
            throw error;
        }
    },

    encaisserBL: async (id, data) => {
        const response = await axiosInstance.post(`/api/ventes/bon-livraison-encaisser/${id}`, JSON.stringify(data));
        return response;
    },
    generatePdf: async (deliveryDTO) => {
        const response = await axiosInstance.post(`/api/deliveryNotes/report`, deliveryDTO, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },
    annuler: async (deliveryId) => {
        const response = await axiosInstance.get(`/api/ventes/bon-livraison/annuler/${deliveryId}`);
        return response.data;
    },
    filter: async (query) => {
        return axiosInstance.post(`/api/deliveryNotes/search`, JSON.stringify(query));
    },
    getLastSaved: async () => {
        return await axiosInstance.get(`/api/deliveryNotes/last-saved`);

    }
}

export default deliveryService;